module.exports = __webpack_public_path__ + "media/images/common/btn-favorite-on-815c956c84290f71db08ea56081e2f87.svg";